import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const FlagUk = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 52 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_430_39)">
        <path
          d="M3.38021 34.3126H49.0769C50.546 34.2329 51.7286 33.0553 51.7286 31.6298V2.99543C51.7286 1.52564 50.4813 0.321476 48.9476 0.312622H3.50955C1.97586 0.321476 0.728577 1.52564 0.728577 2.99543V31.621C0.728577 33.0553 1.91119 34.2329 3.38021 34.3126Z"
          fill="#FEFEFE"
        />
        <path
          d="M22.6623 20.7038V34.3126H29.7579V20.7038H51.7286V13.9038H29.7579V0.312622H22.6623V13.9038H0.728577V20.7038H22.6623Z"
          fill="#C8102E"
        />
        <path
          d="M32.1232 11.3184V0.312622H48.9661C50.1302 0.33033 51.1281 1.02981 51.5346 2.01262L32.1232 11.3184Z"
          fill="#012169"
        />
        <path
          d="M32.1232 23.3069V34.3126H49.077C50.1949 34.2506 51.1373 33.56 51.5346 32.6126L32.1232 23.3069Z"
          fill="#012169"
        />
        <path
          d="M20.2971 23.3069V34.3126H3.38022C2.26228 34.2506 1.31065 33.56 0.922607 32.5949L20.2971 23.3069Z"
          fill="#012169"
        />
        <path
          d="M20.2971 11.3184V0.312622H3.49109C2.32696 0.33033 1.31989 1.03866 0.922607 2.03033L20.2971 11.3184Z"
          fill="#012169"
        />
        <path d="M0.728577 11.6459H7.79651L0.728577 8.25476V11.6459Z" fill="#012169" />
        <path d="M51.7286 11.6459H44.6237L51.7286 8.23706V11.6459Z" fill="#012169" />
        <path d="M51.7286 22.9792H44.6237L51.7286 26.3881V22.9792Z" fill="#012169" />
        <path d="M0.728577 22.9792H7.79651L0.728577 26.3704V22.9792Z" fill="#012169" />
        <path
          d="M51.7286 3.19019L34.1281 11.6459H38.0639L51.7286 5.09383V3.19019Z"
          fill="#C8102E"
        />
        <path
          d="M18.2922 22.9792H14.3563L0.728577 29.5136V31.4173L18.3291 22.9792H18.2922Z"
          fill="#C8102E"
        />
        <path
          d="M10.4481 11.6549H14.384L0.728577 5.10278V6.99758L10.4481 11.6549Z"
          fill="#C8102E"
        />
        <path
          d="M41.9628 22.9705H38.0269L51.7285 29.5491V27.6543L41.9628 22.9705Z"
          fill="#C8102E"
        />
      </g>
      <defs>
        <clipPath id="clip0_430_39">
          <rect width="51" height="34" fill="white" transform="translate(0.728577 0.312622)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
